import React from 'react';
import { Calendar } from '@fitogram/react-calendar';
import '@fitogram/react-calendar/dist/index.css';
import { WHITE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { CalendarDatePickerDay } from './CalendarDatePickerDay';
import { CalendarDatePickerNavigation } from './CalendarDatePickerNavigation';
import { CalendarDatePickerWeekDay } from './CalendarDatePickerWeekDay';
import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';

const useStyles = makeStyles(
  (theme) => ({
    calendarRoot: {
      width: '100% !important',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 200,
      borderRadius: '0 !important',
      padding: '55px 0 10px',
      backgroundColor: WHITE,
      '&::after': {
        content: '""',
        bottom: 0,
        position: 'absolute',
      },
      [theme.breakpoints.down('md')]: {
        padding: '0 10px 10px',
      },
    },
    title: {
      fontSize: FONT_SIZE_MEDIUM,
      gridArea: 'header',
      fontWeight: 'bold',
    },
  }),
  { name: 'CalendarDatePicker' },
);

export interface CalendarComponentProps {
  onTodayClick: () => void;
  calendarController: any;
}

export const CalendarDatePicker = ({ calendarController }: CalendarComponentProps) => {
  const { classes } = useStyles();

  return (
    <Calendar
      classes={{ root: classes.calendarRoot }}
      renderDay={({ day, onSelect }) => (
        <CalendarDatePickerDay
          day={day}
          onClick={onSelect}
          focusedDay={calendarController.focusedDay}
          selectedDay={calendarController.selectedDay}
        />
      )}
      renderNavigation={() => (
        <CalendarDatePickerNavigation
          onNext={calendarController.selectNext}
          onPrev={calendarController.selectPrevious}
          focusedDay={calendarController.focusedDay}
        />
      )}
      data-testid="calendar"
      renderWeekDays={CalendarDatePickerWeekDay}
      renderWeekends={CalendarDatePickerWeekDay}
      weekDaysClasses={{ weekday: classes.calendarWeekday }}
      calendarController={calendarController}
    />
  );
};
